import { FC, useMemo } from 'react';
import NextButton from '../NextButton';
import { PulseLoader } from 'react-spinners';
import { useFormStepTranslation } from './useFormStepTranslation';

type Props = {
	onSubmit(): void;
	submitting: boolean;
	disabled: boolean;
};

export const SubmitButton: FC<Props> = ({ submitting, disabled, onSubmit }) => {
	const { t } = useFormStepTranslation();
	const buttonMessage = t('button-message');

	const content = useMemo(() => {
		if (!submitting) return buttonMessage;

		return <SubmittingLoader />;
	}, [submitting]);

	return <NextButton text={content} disabled={disabled} onClick={onSubmit} />;
};

const SubmittingLoader = () => {
	return <PulseLoader color="#fff" size={12} />;
};
